
const typeHierarchy = window.NjCollection.product_type_hierarchy;

let debounce_timer;
function debounce(func, timeout = 300){
  return (...args) => {
    clearTimeout(debounce_timer);
    debounce_timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function onProductListChanged(mutationsList, observer) {
  for (const mutation of mutationsList) {
    // Currently this function is called twice for a single filter application.
    // TODO: Applying debounce will show the non-tree list for a while, which doesn't seem nice.
    if (!mutation.target.classList.contains('is-loading')) {
      onProductTypeFilterLoad();
    }
  }
}

const observer = new MutationObserver(onProductListChanged);
const observerConfig = { attributes: true, childList: false, subtree: false };
const productListElm = document.querySelector('.shopify-section.shopify-section--main-collection');
observer.observe(productListElm, observerConfig);

function onProductTypeFilterLoad(event) {
  const filterContainerElms = document.querySelectorAll('#accordion-filter-p-product_type');
  filterContainerElms.forEach(filterContainerElm => {
    transformToTree(filterContainerElm);
  });
}
document.addEventListener('DOMContentLoaded', onProductTypeFilterLoad);

function transformToTree(filterContainerElm) {
  const filterValueElms = filterContainerElm.querySelectorAll('input[name="filter.p.product_type"]');

  let filterValues = {};
  filterValueElms.forEach(filterValueElm => {filterValues[filterValueElm.value] = filterValueElm;})

  const accordionTemplateElm = filterContainerElm.parentElement.querySelector('#accordion-filter-p-empty');
  accordionTemplateElm.style.display = 'none';

  for (var typeLv1 in typeHierarchy) {
    if (filterValues[typeLv1] !== undefined) {
      filterValues[typeLv1].setAttribute('level', 1);

      // Merge already rendered filter values with a cloned accordion template that we had
      const newAccordionElm = accordionTemplateElm.cloneNode(true);
      newAccordionElm.hidden = false;
      newAccordionElm.style.display = 'block';
      newAccordionElm.classList.remove('accordion');

      const accordionLabel = newAccordionElm.querySelector('.accordion__toggle > span');
      accordionLabel.textContent = typeLv1;
      const currentLv1Elm = filterValues[typeLv1].parentNode;
      currentLv1Elm.removeChild(currentLv1Elm.children[1]);
      currentLv1Elm.appendChild(newAccordionElm);

      typeHierarchy[typeLv1].forEach(typeLv2 => {
        if (filterValues[typeLv2] !== undefined) {
          // Move lv2 product elementss into the accordion content
          const currentLv2Elm = filterValues[typeLv2].parentNode;
          const lv2Checkbox = currentLv2Elm.children[0];
          // We'll use this attribute to automatically check child checkboxes when its parent is clicked
          lv2Checkbox.setAttribute('parent-value', typeLv1);
          lv2Checkbox.setAttribute('level', 2);

          const lv2ContentElm = newAccordionElm.querySelector('.accordion__content > .checkbox-list');
          lv2ContentElm.appendChild(currentLv2Elm);
        }
      });
    }
  }
}
